import { useState } from "react";
import Dropdown from "@shared/v2/Dropdown";
import PropTypes from "prop-types";
import TransactlyUser from "./TransactlyUser";

const TransactlyCoordinators = ({ users }) => {
  const [allUsers, setAllUsers] = useState(users);

  const userOptions = allUsers.map((u) => {
    const label = `${u.first_name} ${u.last_name} (${u.email})`;

    return { value: u.id, label };
  });

  const [selectedUser, setSelectedUser] = useState(null);

  const onSelectUser = async (newUserOption) => {
    const user = allUsers.find((u) => {
      return u.id === newUserOption.value;
    });

    setSelectedUser(user);
  };

  const onChangeTeam = async ({ userId, newAllUsers }) => {
    setAllUsers(newAllUsers);

    const updatedUser = newAllUsers.find((u) => {
      return u.id === userId;
    });

    setSelectedUser(updatedUser);
  };

  const findOption = (userId) => {
    if (!userId) {
      return null;
    }

    return userOptions.find((o) => {
      return o.value === userId;
    });
  };

  return (
    <div className="content-wrap">
      <div className="container">
        <div className="row">
          <div className="panel">
            <div className="panel-header">Transactly Coordinators</div>

            <div className="panel-body">
              <Dropdown
                options={userOptions}
                value={findOption(selectedUser?.id)}
                label="User"
                name="selected_user"
                onChange={onSelectUser}
              />

              {selectedUser && <TransactlyUser onChangeTeam={onChangeTeam} user={selectedUser} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TransactlyCoordinators.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default TransactlyCoordinators;
